import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import DeactivateVirtualCardContent from 'src/app/DeactivateVirtualCardContent/DeactivateVirtualCardContent'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { useModalRoute } from 'src/navigation/modalParams'
import { deactivateOverlayLocation } from 'src/navigation/overlayRoutes'
import {
  getVirtualCard,
  getVirtualCardPermissions,
} from 'src/redux/actions/data/virtualCards.actions'
import { selectVirtualCardListModels } from 'src/redux/selectors/data/virtualCards.selectors'

const DeactivateVirtualCard: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const location = useLocation()
  // The card id now lives in the `modalId` query param, not a route `:id`.
  const { params } = useModalRoute()
  const virtualCardId = params.id
  const virtualCardListModels = useSelector(selectVirtualCardListModels)
  const virtualCard =
    virtualCardId !== undefined
      ? virtualCardListModels[virtualCardId]
      : undefined

  useEffect((): void => {
    if (virtualCardId === undefined) return
    // Fetch once per card id. (Depending on `virtualCard?.status` re-fired this
    // when the fetch landed and status went undefined -> ACTIVE — a redundant
    // round-trip on every open.)
    dispatch(getVirtualCard(virtualCardId))
    dispatch(getVirtualCardPermissions(virtualCardId))
  }, [virtualCardId])

  useEffect(() => {
    if (virtualCard === undefined) return

    const canonicalDeactivateOverlayLocation = deactivateOverlayLocation(
      virtualCard.id,
      virtualCard.isBillPay,
    )

    if (location.pathname !== canonicalDeactivateOverlayLocation.pathname) {
      dispatch(
        connectedReplace({
          ...canonicalDeactivateOverlayLocation,
          hash: '',
          state: {},
        }),
      )
    }
  }, [location.pathname, virtualCard])

  return <DeactivateVirtualCardContent virtualCard={virtualCard} />
}

export default DeactivateVirtualCard
